import html2canvas from 'html2canvas'

const toPNG = function (element) {
  return toDataURL(element, {type: 'image/png'})
}

const toJPEG = function (element, quality) {
  return toDataURL(element, {type: 'image/jpeg', quality})
}

const toPerfectImage = function (element) {
  return toDataURL(element, {type: 'image/jpeg', quality: 1})
}

const toDataURL = function (element, {type, quality}) {
  return html2canvas(element, {logging: false}).then(canvas => canvas.toDataURL(type, quality)).catch(console.error)
}

export {
  toPNG,
  toJPEG,
  toPerfectImage
}



// WEBPACK FOOTER //
// ./src/app/clientLogic/html2canvas/utility.js